"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentModes = exports.PaymentMode = void 0;
var PaymentMode;
(function (PaymentMode) {
    PaymentMode["Single"] = "Single";
    PaymentMode["Multi"] = "Multi";
})(PaymentMode = exports.PaymentMode || (exports.PaymentMode = {}));
exports.PaymentModes = Object.values(PaymentMode);
//# sourceMappingURL=payment-mode.js.map